// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"e46b36b1","74":"fce399e5","451":"748730c0"}[chunkId] + ".chunk.js";
};